"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if input is a real number.
 *
 * @export
 * @class IsNumberValidator
 * @implements {PropertyValidator<any>}
 */
class IsNumberValidator {
    isValid(input) {
        return input instanceof Number || typeof input === "number";
    }
}
exports.IsNumberValidator = IsNumberValidator;
//# sourceMappingURL=IsNumberValidator.js.map